import actions from './actions';
import {apiRoot, createApiMiddleware, defaultFetchOptions} from '../middleware';
import {registerMiddleware} from '@homeaway/redux-middleware-adapter';
import routes, {API} from '../../routes';

const fetchCount = createApiMiddleware({
    start: actions.FETCH_COUNT_START,
    success: actions.FETCH_COUNT_SUCCESS,
    error: actions.FETCH_COUNT_ERROR,
    apiHandler: ({boardId}) => {
        return fetch(`${apiRoot}/${boardId}/collaboratorCount`);
    }
});

export const fetchInvite = createApiMiddleware({
    start: actions.FETCH_INVITE_START,
    success: actions.FETCH_INVITE_SUCCESS,
    error: actions.FETCH_INVITE_ERROR,
    apiHandler: ({boardId}) => {
        const options = {
            ...defaultFetchOptions,
            method: 'POST',
            body: JSON.stringify({
                tripBoardUuid: boardId
            })
        };
        return fetch(`${routes.TRIPBOARD}/api/tripBoardInvitations`, options);
    }
});

export const fetchLogin = createApiMiddleware({
    start: actions.FETCH_LOGIN_START,
    success: actions.FETCH_LOGIN_SUCCESS,
    error: actions.FETCH_LOGIN_ERROR,
    apiHandler: ({fullLocale, siteName}) => {
        return fetch(`${API}/header/bceHeader?site=${siteName}&locale=${fullLocale}`, defaultFetchOptions);
    }
});

export function registerAllMiddleware() {
    registerMiddleware(actions.FETCH_COUNT, fetchCount);
    registerMiddleware(actions.FETCH_INVITE, fetchInvite);
    registerMiddleware(actions.FETCH_LOGIN, fetchLogin);
}

export default registerAllMiddleware;


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/middleware.js